// src/api/quality/meta.js
import api from "../axios";

/**
 * 품질문서 메타 생성
 *
 * 백엔드 규칙 (QualityDocMetaViewSet.create):
 * - URL: POST /api/quality/meta/?project=PJT001
 * - Body: { meta: { ... } }
 * - meta.__client__.form_type 로 MI/PC/NC/CAR 등 판별
 * - meta.__client__.level2 로 GEN/APR 판별 (없으면 GEN)
 *
 * 여기서는 FormContentManager에서 넘겨주는 metaPayload를 그대로 meta로 감싸서 보낸다고 보면 됩니다.
 */
export const createQualityMeta = async (values) => {
  if (!values?.meta) {
    throw new Error("meta가 없습니다! values.meta를 반드시 설정하세요.");
  }

  const res = await api.post("/quality/meta/", {
    meta: values.meta,
  });
  return res.data;
};

/**
 * 품질문서 메타 단건 조회
 *
 * 백엔드:
 * - lookup_field = "doc_dns"
 * - URL: GET /api/quality/meta/<doc_dns>/
 */
// export const getQualityMeta = async ({ dns }) => {
//   if (!dns) throw new Error("getQualityMeta: dns가 필요합니다.");

//   const res = await api.get(`/quality/meta/${encodeURIComponent(dns)}/`);
//   return res.data;
// };

/**
 * 품질문서 메타 수정 (PATCH)
 *
 * 백엔드:
 * - URL: PATCH /api/quality/meta/<doc_dns>/
 * - Body: { meta: { ... } } 형태 사용
 */
export const updateQualityMeta = async (dns, values) => {
  const res = await api.patch(`/quality/meta/${encodeURIComponent(dns)}/`, {
    meta: values,
  });
  return res.data;
};


/**
 * 품질문서 메타 목록 조회
 *
 * 백엔드:
 * - URL: GET /api/quality/meta/?project=PJT001&...(필터)
 * - project 없으면 400
 * - 결과 없으면 200 + 빈 배열 또는 pagination 결과 (404 아님)
 */
export const getQualityMetaList = async (params = {}) => {
  const { project, ...rest } = params;
  if (!project) throw new Error("getQualityMetaList: project가 필요합니다.");

  const res = await api.get("/quality/meta/", {
    params: { project, ...rest },
  });

  const data = res.data;

  // 배열로 내려오면 그대로, pagination이면 그대로 반환
  if (Array.isArray(data)) return data;
  if (Array.isArray(data?.results)) return data;

  return data || [];
};

export const deleteQualityMeta = async ({ dns }) => {
  if (!dns) throw new Error("deleteQualityMeta: dns가 필요합니다.");

  const res = await api.delete(`/quality/meta/${encodeURIComponent(dns)}/`);
  return res.data;
};

// export const getQualityMeta = async ({ dns }) => {
//   if (!dns) throw new Error("getQualityMeta: dns가 필요합니다.");

//   const raw = await api.get(`/quality/meta/${encodeURIComponent(dns)}/`);
//   const data = raw.data;

//   // 백엔드: { doc_dns, meta, doc } 구조 → 표준 구조로 변환
//   const normalized = {
//     // 기본 문서 정보
//     dns: data.doc_dns,
//     title: data.doc?.title || data.meta?.form?.title || "",
//     created_at: data.doc?.created_at,
//     created_by: data.doc?.created_by,
//     status: data.doc?.status,

//     // meta 원본
//     meta: data.meta || {},

//     // 필요하면 doc 원본도 남겨둔다.
//     doc: data.doc,
//   };

//   return normalized;
// };

export const getQualityMeta = async ({ dns }) => {
  if (!dns) throw new Error("getQualityMeta: dns가 필요합니다.");

  const raw = await api.get(`/quality/meta/${encodeURIComponent(dns)}/`);
  return raw.data; // ⭐ 그대로 반환 (핵심)
};

/**
 * 품질문서 메타 반려 처리
 * 
 * 백엔드:
 * - URL: POST /api/quality/meta/<doc_dns>/reject/
 * - Body: { reason: "...", pc_dns: "..." }
 * - Papers.Docs의 status를 'rejected'로 변경
 */
export const rejectQualityMeta = async (dns, data = {}) => {
  if (!dns) throw new Error("rejectQualityMeta: dns가 필요합니다.");

  const res = await api.post(`/quality/meta/${encodeURIComponent(dns)}/reject/`, data);
  return res.data;
};

/**
 * 품질문서 메타 승인 처리
 * 
 * 백엔드:
 * - URL: POST /api/quality/meta/<doc_dns>/approve/
 * - Body: { comment: "...", pc_dns: "..." }
 * - Papers.Docs의 status를 'approved'로 변경
 */
export const approveQualityMeta = async (dns, data = {}) => {
  if (!dns) throw new Error("approveQualityMeta: dns가 필요합니다.");

  const res = await api.post(`/quality/meta/${encodeURIComponent(dns)}/approve/`, data);
  return res.data;
};
